<template>
  <vue-modal
    @opened="processContentModal()"
    @closed="resetContentModal"
    :delay="100"
    :pivotY="0.3"
    name="sizeGuideModal"
    width="75%"
    height="auto"
  >
    <section
    v-html="rawData"
    ref="sizeGuideContentModal"
    class="buy-panel-size-guide-modal"></section>
  </vue-modal>
</template>

<script>
export default {
  name: 'sizeGuideModal',
  data() {
    return {
      rawData: ''
    }
  },
  methods: {
    openModal() {
      const sizeGuideUrl = this.$store.state.utils.pdm.size_guide_url;
      if (!sizeGuideUrl) return;
      this.$store.dispatch('buyPanel/GET_SIZE_GUIDE_MODAL_CONTENT', sizeGuideUrl).then(response => {
        this.rawData = response;
        this.$modal.show('sizeGuideModal');
      });
    },
    processContentModal(add = true) {
      const rawCloseButton = this.$refs.sizeGuideContentModal.getElementsByClassName('close-modal__size');
      if (!rawCloseButton.length) return;
      const modalEventListener = add ? 'addEventListener' : 'removeEventListener';
      rawCloseButton[0][modalEventListener]('click', this.exit);
    },
    resetContentModal() {
      this.rawData = '';
    },
    exit() {
      this.processContentModal(false);
      this.$modal.hide('sizeGuideModal');
      this.$eventBus.$emit('show-buy-panel');
    }
  },
  mounted() {
    this.$eventBus.$on('show-guide-size-modal', this.openModal);
  },
  beforeDestroy() {
    this.$eventBus.$off('show-guide-size-modal', this.openModal);
  }
}
</script>
